exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-525ec2f8] .el-scrollbar__bar{opacity:1}\n", ""]);

// exports
